import React from 'react'
import { useSelector } from 'react-redux';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';
import clsx from 'clsx';

import _ from 'lodash';
import { isTrue, describeDate } from '../utils';

const CartContents = ({flexLayout, handleRemoveItem}) => {
	const classes = useStyles();
	const cart = useSelector(state => state.cart.data);
	const member = useSelector(state => state.member.data);
	const isMd = useMediaQuery('(min-width:960px)');
	
	const courseFields = {
		course_code: 'Code',
		course_name: 'Name',
		start_date: 'Start date',
		waitlist: 'Status',
		fee: 'Fee',
	}
	
	const formatField = (type, value) => {
		switch(type){
			case 'start_date':
				return describeDate(value);
			case 'waitlist':
				return isTrue(value) ? 'Waitlist' : 'OK';
			case 'fee':
				return '$' + value;
			default:
				return value;
		}
	}
	
	let hasWaitlist = false;
	const cartTotal = _.sumBy(cart, c => { 
		if(isTrue(c.waitlist) && _.toNumber(c.fee) > 0){
			hasWaitlist = true;
			return 0;
		} else {
			return _.toNumber(c.fee) 
		}
	});
	
	return cart.length === 0 ? (
		<Typography paragraph>There are no items in your cart.</Typography>
	) : (
	<>
	{_.isEmpty(member.enrolled_subscription) && !isTrue(member.current_member) ? 
	<Typography paragraph>
	You do not have a current membership: A membership subscription will be automatically added to your cart if required.
	</Typography>
	: null }
	<Table className={classes.cartTable} size={isMd ? "medium" : "small"}>
	{flexLayout ? null :
	<TableHead>
	<TableRow>
	<TableCell></TableCell>
	{_.map(courseFields, (f, k) => (
		<TableCell key={k}>
			{f}
		</TableCell>
	))}
	</TableRow>
	</TableHead>
	}
	<TableBody className={flexLayout ? clsx(classes.flexCartTable, classes.flexTable) : null}>
	{_.map(cart, c => (
		<TableRow key={c.course_code} className={isTrue(c.waitlist) ? classes.waitlistItem : null}>
		<TableCell>
		<IconButton color="primary" size={isMd ? "medium" : "small"}
			onClick={() => handleRemoveItem(c.course_code)} 
		>
		<DeleteIcon />
		</IconButton>
		</TableCell>
		{_.map(courseFields, (f, k) => (
			<TableCell key={k}>
				{flexLayout ? <strong>{courseFields[k]}: </strong> : null}{formatField(k, c[k])}
			</TableCell>
		))}
		</TableRow>
	))}
	<TableRow>
	<TableCell colSpan={4}>{hasWaitlist ?
	<Typography variant='body2'>
	Waitlist enrolments will not be charged at checkout. If a waitlist enrolment is later converted to a full enrolment, your invoice will be updated at that time. 
	</Typography>
	: null }</TableCell>
	<TableCell align="right">Total</TableCell>
	<TableCell>${cartTotal.toFixed(2)}</TableCell>
	</TableRow>
	</TableBody>
	</Table>
	</>
)};

export default CartContents